import { DefaultSecondaryButton } from "@/styles/globalstyles";
import { Button } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";

const ActivateButton = ({
  type,
  disabled,
  onClick,
}: {
  type: number;
  disabled?: boolean;
  onClick?: () => void;
}) => {
  const isDeactivate = type === 0;
  const themeColor = isDeactivate ? "#d32f2f" : "success.light";

  return (
    <Button
      variant="outlined"
      size="small"
      disabled={disabled}
      onClick={onClick}
      sx={{
        ...DefaultSecondaryButton,
        fontSize: "0.75rem",
        width: 130,
        color: themeColor,
        borderColor: themeColor,
      }}
    >
      {isDeactivate ? <DoNotDisturbIcon /> : <CheckIcon />}
      {isDeactivate ? " Deactivate" : " Activate"}
    </Button>
  );
};

export default ActivateButton;